import { render, staticRenderFns } from "./PointCardList.vue?vue&type=template&id=63f90b59&scoped=true&"
import script from "./PointCardList.vue?vue&type=script&lang=js&"
export * from "./PointCardList.vue?vue&type=script&lang=js&"
import style0 from "./PointCardList.vue?vue&type=style&index=0&id=63f90b59&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f90b59",
  null
  
)

export default component.exports